import {Tag} from './tag.model';

export class TagCategory{
    title: string;
    tags: Array<Tag> = [];
    tabSelected: boolean;
    id:number;
    tagSelectedCount: number;
    oldTagSelectedCount: number = 0;
}


// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/shared/models/tag-category.model.ts